import React, { Component } from "react";
import phoneIcon from "../images/phone-icon.svg";

export default class PhoneButton extends Component {
  constructor(props) {
    super(props);
    this.phone_number = props.attributes;
  }

  state = {
    seen: false,
  };

  togglePop = () => {
    this.setState({
      seen: !this.state.seen,
    });
  };

  render() {
    return (
      <a href={"tel:" + this.phone_number} className="phone_icon_button">
      <img src={phoneIcon} width="50" height="50"/>
          </a>
    );
  }
}
